/* Size guide drawer: open/close, tabs, focus trap, Escape to close. No dependencies. */
(function () {
  // A scope is a drawer (.size-guide) or a hub card/page ([data-size-guide-scope]).
  function scopeOf(el) { return el.closest('[data-size-guide-scope], .size-guide'); }

  function openGuide(id, trigger) {
    var guide = document.getElementById(id);
    if (!guide) return;
    guide.hidden = false;
    document.body.style.overflow = 'hidden';
    guide.dataset.returnFocus = trigger && trigger.id ? trigger.id : '';
    var closeBtn = guide.querySelector('.size-guide__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeGuide(guide) {
    guide.hidden = true;
    document.body.style.overflow = '';
    var trigger = document.querySelector('[data-size-guide-open="' + guide.id + '"]');
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-guide-open]');
    if (open) { openGuide(open.getAttribute('data-size-guide-open'), open); return; }

    var close = e.target.closest('[data-size-guide-close]');
    if (close) { closeGuide(close.closest('.size-guide')); return; }

    var tab = e.target.closest('[data-size-guide-tab]');
    if (tab) {
      var guide = scopeOf(tab);
      var i = tab.getAttribute('data-size-guide-tab');
      guide.querySelectorAll('[data-size-guide-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      guide.querySelectorAll('[data-size-guide-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-size-guide-panel') === i);
      });
    }
  });

  // cm / mm → inches toggle. Converts every numeric part of a cell ("96-102", "279+", "46") and leaves text alone.
  function toInches(value, unit) {
    var div = unit === 'mm' ? 25.4 : unit === 'cm' ? 2.54 : null;
    if (!div) return value;
    return value.replace(/\d+(\.\d+)?/g, function (n) {
      var v = parseFloat(n) / div;
      return (Math.round(v * 10) / 10).toString();
    });
  }

  function setUnits(guide, system) {
    guide.querySelectorAll('[data-size-guide-units]').forEach(function (b) {
      var on = b.getAttribute('data-size-guide-units') === system;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    guide.querySelectorAll('[data-size-guide-value]').forEach(function (td) {
      var raw = td.getAttribute('data-size-guide-value');
      var unit = td.getAttribute('data-size-guide-unit');
      td.textContent = system === 'imperial' ? toInches(raw, unit) : raw;
    });
    guide.querySelectorAll('[data-size-guide-unit-label]').forEach(function (s) {
      var unit = s.getAttribute('data-size-guide-unit-label');
      s.textContent = '(' + (system === 'imperial' && (unit === 'cm' || unit === 'mm') ? 'in' : unit) + ')';
    });
    guide.querySelectorAll('.size-guide__finder-input em').forEach(function (em) {
      var base = em.getAttribute('data-unit') || em.textContent;
      em.setAttribute('data-unit', base);
      em.textContent = system === 'imperial' && (base === 'cm' || base === 'mm') ? 'in' : base;
    });
    var fields = guide.querySelector('[data-size-guide-finder-fields]');
    if (fields) fields.dispatchEvent(new Event('input', { bubbles: true }));
    try { localStorage.setItem('bp-size-guide-units', system); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var u = e.target.closest('[data-size-guide-units]');
    if (u) setUnits(scopeOf(u), u.getAttribute('data-size-guide-units'));
  });

  // Remember the shopper's last choice.
  try {
    var saved = localStorage.getItem('bp-size-guide-units');
    if (saved === 'imperial') document.querySelectorAll('.size-guide, [data-size-guide-scope]').forEach(function (g) { setUnits(g, 'imperial'); });
  } catch (e) {}

  /* ---------- Find my size (rule-based recommender) ----------
     Reads the active table's rows from the DOM, builds one input per measurement column,
     and scores each size by how many of the shopper's measurements fall inside its range.
     Range cells look like "96-102", "279+", "46"; a ± tolerance of 1 cm / 10 mm catches boundaries. */

  function parseRange(text, unit) {
    var t = text.replace(/\s/g, '');
    var tol = unit === 'mm' ? 10 : 1;
    var m;
    if ((m = t.match(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/))) return { lo: +m[1], hi: +m[2], tol: tol };
    if ((m = t.match(/^(\d+(?:\.\d+)?)\+$/))) return { lo: +m[1], hi: Infinity, tol: tol };
    if ((m = t.match(/^(\d+(?:\.\d+)?)$/))) return { lo: +m[1] - tol * 2, hi: +m[1] + tol * 2, tol: tol };
    return null;
  }

  function activeTable(guide) {
    var panel = guide.querySelector('.size-guide__table-wrap.is-active') || guide.querySelector('.size-guide__table-wrap');
    if (!panel) return null;
    var heads = Array.prototype.slice.call(panel.querySelectorAll('thead th')).map(function (th) { return th.firstChild ? th.firstChild.textContent.trim() : th.textContent.trim(); });
    var rows = Array.prototype.slice.call(panel.querySelectorAll('tbody tr')).map(function (tr) {
      var cells = Array.prototype.slice.call(tr.children);
      return {
        size: cells[0].textContent.trim(),
        ranges: cells.slice(1).map(function (td) { return parseRange(td.getAttribute('data-size-guide-value') || td.textContent, td.getAttribute('data-size-guide-unit')); }),
        units: cells.slice(1).map(function (td) { return td.getAttribute('data-size-guide-unit'); })
      };
    });
    return { columns: heads.slice(1), rows: rows };
  }

  function buildFinder(guide) {
    var finder = guide.querySelector('[data-size-guide-finder]');
    if (!finder) return;
    var table = activeTable(guide);
    var fields = finder.querySelector('[data-size-guide-finder-fields]');
    var result = finder.querySelector('[data-size-guide-finder-result]');
    fields.innerHTML = '';
    result.textContent = '';
    if (!table || !table.rows.length) { finder.hidden = true; return; }
    finder.hidden = false;

    // Only offer inputs for columns that are numeric ranges in at least one row.
    table.columns.forEach(function (col, i) {
      var usable = table.rows.some(function (r) { return r.ranges[i]; });
      if (!usable) return;
      var unit = table.rows[0].units[i] || 'cm';
      var id = (guide.id || 'sg') + '-f' + i;
      var wrap = document.createElement('label');
      wrap.className = 'size-guide__finder-field';
      wrap.innerHTML = '<span>' + col + '</span><span class="size-guide__finder-input"><input type="number" inputmode="decimal" min="0" step="0.5" id="' + id + '" data-col="' + i + '"><em>' + unit + '</em></span>';
      fields.appendChild(wrap);
    });

    function recommend() {
      var inputs = Array.prototype.slice.call(fields.querySelectorAll('input'));
      var entered = inputs.filter(function (inp) { return inp.value !== '' && !isNaN(parseFloat(inp.value)); });
      if (!entered.length) { result.innerHTML = ''; return; }

      var scored = table.rows.map(function (row) {
        var hits = 0, near = 0, distance = 0;
        entered.forEach(function (inp) {
          var col = +inp.getAttribute('data-col');
          var r = row.ranges[col];
          var v = parseFloat(inp.value);
          if (!r) return;
          // Inputs are typed in whatever units the toggle shows; score in the table's own units.
          var imperial = guide.querySelector('[data-size-guide-units="imperial"].is-active');
          var unit = row.units[col];
          if (imperial && unit === 'cm') v = v * 2.54;
          if (imperial && unit === 'mm') v = v * 25.4;
          if (v >= r.lo && v <= r.hi) hits++;
          else if (v >= r.lo - r.tol && v <= r.hi + r.tol) near++;
          else distance += v < r.lo ? r.lo - v : (r.hi === Infinity ? 0 : v - r.hi);
        });
        return { size: row.size, hits: hits, near: near, distance: distance };
      });

      scored.sort(function (a, b) { return (b.hits - a.hits) || (b.near - a.near) || (a.distance - b.distance); });
      var best = scored[0], runner = scored[1];
      var n = entered.length;

      var html;
      if (best.hits === n) {
        html = '<strong>Recommended size: ' + best.size + '</strong>';
        if (runner && runner.hits + runner.near === n && runner.near > 0) html += '<br>You are close to the ' + runner.size + ' on one measurement; if you like a looser fit, consider it.';
      } else if (best.hits + best.near === n) {
        html = '<strong>Recommended size: ' + best.size + '</strong><br>You are on a size boundary. For a close fit stay with ' + best.size + '; for extra room pick the next size up.';
      } else if (best.hits > 0 || best.near > 0) {
        var alt = runner && (runner.hits + runner.near) > 0 ? ' or ' + runner.size : '';
        html = '<strong>Closest match: ' + best.size + alt + '</strong><br>Your measurements fall across two sizes. Go by the measurement that matters most for this garment (chest for tops, waist for bottoms) and ask us if you are unsure.';
      } else {
        html = 'Those measurements sit outside this size range. Double-check the numbers, try another tab (men\'s / women\'s / junior), or ask us before you order.';
      }
      result.innerHTML = html;
      markRow(guide, (best.hits + best.near === n) ? best.size : null);
      if (best.hits + best.near === n) addChoose(guide, result, best.size);
    }

    fields.addEventListener('input', recommend);
  }


  /* ---------- BikeParts product page: "Choose M" button and the shaded row ---------- */
  function normSize(s) {
    s = String(s || '').toLowerCase().replace(/^eu\s*/, '').replace(/\s+/g, '');
    if (s === 'xxl') s = '2xl'; if (s === 'xxxl') s = '3xl'; if (s === 'xxxxl') s = '4xl'; if (s === 'xxs') s = '2xs';
    return s;
  }
  // The size boxes on the product page: radios (sizes of one product) or links (each size is its own product).
  function sizeChoices() {
    var fs = document.querySelector('.bpm__opt .bpm-sg-jump');
    fs = fs ? fs.closest('[data-bpm-opt]') : null;
    if (!fs) return [];
    var out = [];
    fs.querySelectorAll('input[type="radio"]').forEach(function (inp) { out.push({ name: inp.value, el: inp, type: 'radio' }); });
    fs.querySelectorAll('a.bpm__opt-link').forEach(function (a) { var sp = a.querySelector('span'); out.push({ name: sp ? sp.textContent.trim() : a.textContent.trim(), el: a, type: 'link' }); });
    return out;
  }
  function pickedSize() {
    var fs = document.querySelector('.bpm__opt .bpm-sg-jump');
    fs = fs ? fs.closest('[data-bpm-opt]') : null;
    var l = fs ? fs.querySelector('[data-bpm-opt-label]') : null;
    return l ? l.textContent.trim() : '';
  }
  function markRow(guide, size, label) {
    var panel = guide.querySelector('.size-guide__table-wrap.is-active') || guide.querySelector('.size-guide__table-wrap');
    guide.querySelectorAll('tr.is-hit').forEach(function (tr) { tr.classList.remove('is-hit'); var t = tr.querySelector('.size-guide__tag'); if (t) t.remove(); });
    if (!panel || !size) return;
    var want = normSize(size);
    panel.querySelectorAll('tbody tr').forEach(function (tr) {
      var th = tr.children[0];
      if (th && normSize(th.textContent) === want) {
        tr.classList.add('is-hit');
        var tag = document.createElement('span'); tag.className = 'size-guide__tag'; tag.textContent = label || 'Your size';
        th.appendChild(tag);
      }
    });
  }
  function addChoose(guide, result, size) {
    var want = normSize(size), match = null;
    sizeChoices().forEach(function (c) { if (!match && normSize(c.name) === want) match = c; });
    if (!match) return;
    var txt = document.createElement('div'); txt.className = 'size-guide__res-text'; txt.innerHTML = result.innerHTML;
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'size-guide__choose'; btn.textContent = 'Choose ' + match.name;
    btn.addEventListener('click', function () {
      if (match.type === 'link') { window.location.href = match.el.href; return; }
      match.el.checked = true; match.el.click(); match.el.dispatchEvent(new Event('change', { bubbles: true }));
      var drawer = guide.classList.contains('size-guide') ? guide : null;
      if (drawer) { closeGuide(drawer); }
      var row = match.el.closest('[data-bpm-opt]');
      if (row) row.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
    result.innerHTML = '';
    result.appendChild(txt); result.appendChild(btn);
  }
  // When a guide opens, shade the size already picked on the page.
  function showPicked(guide) { var p = pickedSize(); if (p) markRow(guide, p, 'Picked'); }

  // Model drop-down (guides with a chart per model): show that model's chart
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-size-guide-select]');
    if (!sel) return;
    var sc = scopeOf(sel), i = sel.value;
    sc.querySelectorAll('[data-size-guide-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-size-guide-panel') === i); });
    buildFinder(sc); showPicked(sc);
  });

  // Build the finder when a drawer opens, and rebuild when the tab changes.
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-guide-open]');
    if (open) { var g = document.getElementById(open.getAttribute('data-size-guide-open')); if (g) { buildFinder(g); showPicked(g); } }
    var tab = e.target.closest('[data-size-guide-tab]');
    if (tab) setTimeout(function () { var sc = scopeOf(tab); buildFinder(sc); showPicked(sc); }, 0);
  });
  document.querySelectorAll('.size-guide:not([hidden])').forEach(buildFinder);
  document.querySelectorAll('[data-size-guide-scope] details[open]').forEach(function (d) { var sc = scopeOf(d); if (sc) buildFinder(sc); });
  document.querySelectorAll('.size-guide-card').forEach(buildFinder);

  // Hub page: build each guide's finder when its <details> opens.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.tagName === 'DETAILS' && d.open && !d.classList.contains('size-guide__measure')) { var sc = scopeOf(d); if (sc) { buildFinder(sc); if (d.hasAttribute('data-bpm-sg')) showPicked(sc); } }
  }, true);

  // Hub page: arriving with #hub-<handle> (from a brand page link) opens that guide and scrolls to it.
  function openFromHash() {
    var id = (location.hash || '').slice(1);
    if (!id || id.indexOf('hub-') !== 0) return;
    var card = document.getElementById(id);
    if (!card) return;
    var d = card.querySelector('details');
    if (d && !d.open) d.open = true;
    card.scrollIntoView({ block: 'start' });
  }
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash); else openFromHash();

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.size-guide:not([hidden])');
    if (open) closeGuide(open);
  });
})();
